var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-gallery" },
    [
      _vm.media.length > 0
        ? [
            _c(
              "div",
              { staticClass: "product-gallery__holder" },
              [
                _vm.media.length > 1
                  ? _c(
                      "button",
                      { on: { click: _vm.galleryPrevious } },
                      [
                        _c("Icon", {
                          staticClass: "product-gallery__button",
                          attrs: { name: "chevron-left", size: "44px" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "flickity",
                  {
                    ref: "flickity",
                    staticClass: "product-gallery-main",
                    attrs: { options: _vm.flickityOptions }
                  },
                  [
                    _vm._l(_vm.media, function(mediaItem, mediaIndex) {
                      return [
                        mediaItem.media_type == "image"
                          ? _c(
                              "div",
                              {
                                key: mediaItem.id,
                                staticClass: "carousel-cell carousel-cell-zoom",
                                on: { mousemove: _vm.zoom }
                              },
                              [
                                _c("img", {
                                  staticClass:
                                    "product-gallery__image lazyload image--fade-in",
                                  attrs: {
                                    "data-src": mediaItem.src,
                                    "data-widths":
                                      "[400,500,600,700,800,900,1000,1100,1200]",
                                    "data-sizes": "auto",
                                    alt: mediaItem.alt
                                      ? mediaItem.alt
                                      : `${
                                          _vm.productTitle
                                        } Image ${mediaIndex + 1}`
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy:background-image",
                                      value: _vm.zoomImages[mediaIndex],
                                      expression: "zoomImages[mediaIndex]",
                                      arg: "background-image"
                                    }
                                  ],
                                  staticClass: "product-gallery__image--zoom"
                                })
                              ]
                            )
                          : mediaItem.media_type == "video"
                          ? _c(
                              "div",
                              {
                                key: mediaItem.id,
                                staticClass: "carousel-cell"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "video-wrapper video-wrapper--native",
                                    style: _vm.videoPadding(mediaIndex)
                                  },
                                  [
                                    _c(
                                      "video",
                                      {
                                        staticClass: "product-gallery__video",
                                        attrs: {
                                          muted: "",
                                          controls: "",
                                          playsinline: ""
                                        },
                                        domProps: { muted: true }
                                      },
                                      [
                                        _c("source", {
                                          attrs: {
                                            src: mediaItem.sources[0].url,
                                            type: mediaItem.sources[0].mime_type
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : mediaItem.media_type == "external_video"
                          ? _c(
                              "div",
                              {
                                key: mediaItem.id,
                                staticClass: "carousel-cell"
                              },
                              [
                                _c("div", { staticClass: "video-wrapper" }, [
                                  _c("iframe", {
                                    attrs: {
                                      width: "100%",
                                      height: "100%",
                                      src: _vm.youtubeVideo(
                                        mediaItem.external_id
                                      ),
                                      title: "YouTube video player",
                                      frameborder: "0",
                                      allow:
                                        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;",
                                      allowfullscreen: ""
                                    }
                                  })
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.media.length > 1
                  ? _c(
                      "button",
                      { on: { click: _vm.galleryNext } },
                      [
                        _c("Icon", {
                          staticClass: "product-gallery__button",
                          attrs: { name: "chevron-right", size: "44px" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.media.length > 1
              ? _c(
                  "div",
                  { staticClass: "product-gallery__thumbnails" },
                  [
                    _vm.media.length <= _vm.thumbCount
                      ? _vm._l(_vm.media, function(mediaItem, mediaIndex) {
                          return _c(
                            "div",
                            {
                              key: mediaItem.id,
                              staticClass: "carousel-cell-thumbnail",
                              class: [
                                _vm.selectedGalleryCell == mediaIndex
                                  ? "thumb-selected"
                                  : ""
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.selectCell(mediaIndex)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "product-gallery__thumb lazyload image--fade-in",
                                attrs: {
                                  "data-src": mediaItem.preview_image.src,
                                  "data-widths":
                                    "[400,500,600,700,800,900,1000,1100,1200]",
                                  "data-sizes": "auto",
                                  alt: mediaItem.alt
                                }
                              }),
                              _vm._v(" "),
                              mediaItem.media_type == "video" ||
                              mediaItem.media_type == "external_video"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product-gallery__thumb-overlay"
                                    },
                                    [
                                      _c("Icon", {
                                        attrs: {
                                          name: "video-play",
                                          size: "50px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        })
                      : [
                          _c(
                            "flickity",
                            {
                              ref: "productGalleryThumbnails",
                              class: `product-gallery-thumbs ${_vm.lastSlideClass}`,
                              attrs: { options: _vm.flickityOptionsThumbs }
                            },
                            _vm._l(_vm.media, function(mediaItem, mediaIndex) {
                              return _c(
                                "div",
                                {
                                  key: mediaItem.id,
                                  staticClass: "carousel-cell-thumbnail",
                                  class: [
                                    _vm.selectedGalleryCell == mediaIndex
                                      ? "thumb-selected"
                                      : ""
                                  ],
                                  on: {
                                    click: function($event) {
                                      return _vm.selectCell(mediaIndex)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "product-gallery__thumb lazyload image--fade-in",
                                    attrs: {
                                      "data-src": mediaItem.preview_image.src,
                                      "data-widths":
                                        "[400,500,600,700,800,900,1000,1100,1200]",
                                      "data-sizes": "auto",
                                      alt: mediaItem.alt
                                    }
                                  }),
                                  _vm._v(" "),
                                  mediaItem.media_type == "video" ||
                                  mediaItem.media_type == "external_video"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "product-gallery__thumb-overlay"
                                        },
                                        [
                                          _c("Icon", {
                                            attrs: {
                                              name: "video-play",
                                              size: "50px"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          )
                        ]
                  ],
                  2
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }